import useFeature from '@/hooks/use-feature.hook';
import useMetabase from '@/hooks/use-metabase';
import { MetabaseProvider } from '@surepathai/embedding-sdk-react';
import { ReactNode } from '@tanstack/react-router';
import { FC } from 'react';

interface Props {
  children: ReactNode;
}

const ChartsProvider: FC<Props> = ({ children }) => {
  const { canViewCharts } = useFeature();
  const { authConfig, theme } = useMetabase();

  if (!canViewCharts) {
    return <>{children}</>;
  }

  return (
    <MetabaseProvider authConfig={authConfig} theme={theme}>
      {children}
    </MetabaseProvider>
  );
};

export default ChartsProvider;
